/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_JointInputs */

const en_us2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joint pain`)
};

const pt_br2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor na articulação`)
};

const es_419_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor articular`)
};

const pt_pt2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor na articulação`)
};

const fr_fr2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur articulaire`)
};

const de_de2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelenkschmerz`)
};

const it_it2_workout_after_pain_joint = /** @type {(inputs: Workout_After_Pain_JointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore articolare`)
};

/**
* | output |
* | --- |
* | "Joint pain" |
*
* @param {Workout_After_Pain_JointInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_joint = /** @type {((inputs?: Workout_After_Pain_JointInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_JointInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_joint(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_joint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_joint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_joint(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_joint(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_joint(inputs)
	return en_us2_workout_after_pain_joint(inputs)
});
export { workout_after_pain_joint as "workout-after.pain_joint" }